var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKOUT_CUSTOMER_DISASSOCIATE = exports.CHECKOUT_CUSTOMER_ASSOCIATE = exports.CHECKOUT_GIFTCARDS_APPEND = exports.CHECKOUT_DISCOUNT_REMOVE = exports.CHECKOUT_DISCOUNT_APPLY = exports.CHECKOUT_EMAIL_UPDATE = exports.CHECKOUT_SHIPPING_ADDRESS_UPDATE = exports.CHECKOUT_ATTRIBUTES_UPDATE = exports.CHECKOUT_LINE_ITEMS_REMOVE = exports.CHECKOUT_LINE_ITEM_ADD = exports.CHECKOUT_LINE_ITEMS_REPLACE = exports.CHECKOUT_CREATE = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const checkoutFragment_1 = require("../fragments/checkoutFragment");
const userErrorFragment_1 = require("../fragments/userErrorFragment");
const checkoutUserErrorFragment_1 = require("../fragments/checkoutUserErrorFragment");
exports.CHECKOUT_CREATE = (0, graphql_tag_1.default) `
  mutation CHECKOUT_CREATE($input: CheckoutCreateInput!) {
    checkoutCreate(input: $input) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        code
        field
        message
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
`;
exports.CHECKOUT_LINE_ITEMS_REPLACE = (0, graphql_tag_1.default) `
  mutation checkoutLineItemsReplace($checkoutId: ID!, $lineItems: [CheckoutLineItemInput!]!) {
    checkoutLineItemsReplace(lineItems: $lineItems, checkoutId: $checkoutId) {
      checkout {
        ...CheckoutFragment
      }
      userErrors {
        code
        field
        message
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
`;
exports.CHECKOUT_LINE_ITEM_ADD = (0, graphql_tag_1.default) `
  mutation checkoutLineItemsAdd($lineItems: [CheckoutLineItemInput!]!, $checkoutId: ID!) {
    checkoutLineItemsAdd(lineItems: $lineItems, checkoutId: $checkoutId) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        code
        field
        message
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
`;
exports.CHECKOUT_LINE_ITEMS_REMOVE = (0, graphql_tag_1.default) `
  mutation checkoutLineItemsRemove($checkoutId: ID!, $lineItemIds: [ID!]!) {
    checkoutLineItemsRemove(checkoutId: $checkoutId, lineItemIds: $lineItemIds) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        code
        field
        message
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
`;
exports.CHECKOUT_ATTRIBUTES_UPDATE = (0, graphql_tag_1.default) `
  mutation checkoutAttributesUpdateV2($checkoutId: ID!, $input: CheckoutAttributesUpdateV2Input!) {
    checkoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) {
      userErrors {
        ...UserErrorFragment
      }
      checkoutUserErrors {
        ...CheckoutUserErrorFragment
      }
      checkout {
        ...CheckoutFragment
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
  ${userErrorFragment_1.USER_ERROR_FRAGMENT}
  ${checkoutUserErrorFragment_1.CHECKOUT_USER_ERROR_FRAGMENT}
`;
exports.CHECKOUT_SHIPPING_ADDRESS_UPDATE = (0, graphql_tag_1.default) `
  mutation checkoutShippingAddressUpdateV2($shippingAddress: MailingAddressInput!, $checkoutId: ID!) {
    checkoutShippingAddressUpdateV2(shippingAddress: $shippingAddress, checkoutId: $checkoutId) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        ...CheckoutUserErrorFragment
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
  ${checkoutUserErrorFragment_1.CHECKOUT_USER_ERROR_FRAGMENT}
`;
exports.CHECKOUT_EMAIL_UPDATE = (0, graphql_tag_1.default) `
  mutation checkoutEmailUpdateV2($email: String!, $checkoutId: ID!) {
    checkoutEmailUpdateV2(email: $email, checkoutId: $checkoutId) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        ...CheckoutUserErrorFragment
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
  ${checkoutUserErrorFragment_1.CHECKOUT_USER_ERROR_FRAGMENT}
`;
exports.CHECKOUT_DISCOUNT_APPLY = (0, graphql_tag_1.default) `
  mutation checkoutDiscountCodeApplyV2($discountCode: String!, $checkoutId: ID!) {
    checkoutDiscountCodeApplyV2(discountCode: $discountCode, checkoutId: $checkoutId) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        ...CheckoutUserErrorFragment
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
  ${checkoutUserErrorFragment_1.CHECKOUT_USER_ERROR_FRAGMENT}
`;
exports.CHECKOUT_DISCOUNT_REMOVE = (0, graphql_tag_1.default) `
  mutation checkoutDiscountCodeRemove($checkoutId: ID!) {
    checkoutDiscountCodeRemove(checkoutId: $checkoutId) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        ...CheckoutUserErrorFragment
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
  ${checkoutUserErrorFragment_1.CHECKOUT_USER_ERROR_FRAGMENT}
`;
exports.CHECKOUT_GIFTCARDS_APPEND = (0, graphql_tag_1.default) `
  mutation checkoutGiftCardsAppend($giftCardCodes: [String!]!, $checkoutId: ID!) {
    checkoutGiftCardsAppend(giftCardCodes: $giftCardCodes, checkoutId: $checkoutId) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        ...CheckoutUserErrorFragment
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
  ${checkoutUserErrorFragment_1.CHECKOUT_USER_ERROR_FRAGMENT}
`;
exports.CHECKOUT_CUSTOMER_ASSOCIATE = (0, graphql_tag_1.default) `
  mutation checkoutCustomerAssociateV2($checkoutId: ID!, $customerAccessToken: String!) {
    checkoutCustomerAssociateV2(checkoutId: $checkoutId, customerAccessToken: $customerAccessToken) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        ...CheckoutUserErrorFragment
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
  ${checkoutUserErrorFragment_1.CHECKOUT_USER_ERROR_FRAGMENT}
`;
exports.CHECKOUT_CUSTOMER_DISASSOCIATE = (0, graphql_tag_1.default) `
  mutation checkoutCustomerDisassociateV2($checkoutId: ID!) {
    checkoutCustomerDisassociateV2(checkoutId: $checkoutId) {
      checkout {
        ...CheckoutFragment
      }
      checkoutUserErrors {
        ...CheckoutUserErrorFragment
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
  ${checkoutUserErrorFragment_1.CHECKOUT_USER_ERROR_FRAGMENT}
`;
//# sourceMappingURL=checkout.js.map